<template>
  <WorkBaseRestrictedTextField
    ref="restrictedTextField"
    class="w-percentage-field"
    :value="value"
    v-bind="$props"
    :char-whitelist="internalCharWhiteList"
    :always-allowed-keys="internalAlwaysAllowedKeys"
    :placeholder="internalPlaceholder"
    :array-of-is-valid-functions="validations"
    :input-get-formatter="invokeGetFormatter"
    :input-set-formatter="invokeSetFormatter"
    :format-value-on-focus-out="invokeFormatOnFocusOut"
    :format-value-on-focus-in="invokeFormatOnFocusIn"
    :read-only-formatter="invokeReadonlyFormat"
    :align-right="alignRight"
    :space-between="spaceBetween"
    @input="$emit('input', $event)"
  />
</template>

<script>
// components
import WorkBaseRestrictedTextField from '@/components/global_components/forms/text_fields/WorkBaseRestrictedTextField';

// mixins
import numberFieldMixin from '@/components/global_components/forms/text_fields/mixins/number-field-mixin';
import isRequired from '@/mixins/component/is-required-mixin';
import pendingAble from '@/mixins/component/pending-able-mixin';

// helpers
import { PERCENTAGE_CONFIG } from '@/services/formatter_services/enums/PERCENTAGE_CONFIG';
import {
  formatNumberToPercentage,
  formatPercentageToNumber,
} from '@/services/formatter_services/percentage-formatter';
import { getConfigOf } from '@/services/formatter_services/enums/PERCENTAGE_CONFIG';

export default {
  name: 'WorkPercentageTextField',
  components: { WorkBaseRestrictedTextField },
  props: {
    value: { type: [Number, String] },
    locale: { type: String, default: 'de' },
    alignRight: { type: Boolean, default: false },
    spaceBetween: { type: Boolean, default: false }
  },
  mixins: [
    isRequired,
    pendingAble,
    numberFieldMixin(
      {
        getFormatter: (v, self) => formatNumberToPercentage(v, self.locale),
        setFormatter: (v, self) => formatPercentageToNumber(v, self.locale),
        formatOnFocusOut: (v, self) =>
          formatNumberToPercentage(v, self.locale, true),
        formatToReadonly: (v, self) =>
          formatNumberToPercentage(v, self.locale, true),
      },
      true
    ),
  ],
  computed: {
    validations() {
      return PERCENTAGE_CONFIG?.[this.locale]?.validations ?? [];
    },
    internalPlaceholder() {
      if (this.placeholder != undefined) {
        return this.placeholder;
      }
      return getConfigOf('de').defaultValue;
    },
  },
  methods: {
    focus() {
      this.$refs.restrictedTextField.focus();
    }
  },
};
</script>

<style lang='scss' scoped>
.w-percentage-field ::v-deep {
  .v-text-field__slot input {
    text-align: end !important;
  }
  .w-read-only-text-field__label{
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
</style>
